import { UserChannel } from "constants/UserConstants";
import { FaWhatsappSquare } from "react-icons/fa";
import { FaTelegramPlane } from "react-icons/fa";
import { FaPhoneSquareAlt } from "react-icons/fa";
import { SiMicrosoftteams } from "react-icons/si";
import { Tooltip } from "react-tooltip";
import "./Channels.scss";
import FleetEdgeChannelIcon from "../../images/fleet-edge-icon.svg"

const tooltipStyle = { background: "black", color: "white" };

function Channels(props) {
  const { channels, size } = props;
  const renderChannelIcons = () => {
    return channels.map((channel) => getChannelIcon(channel, size));
  };

  const getChannelIcon = (channel, size) => {
    let icon = "";
    switch (channel) {
      case UserChannel.WHATSAPP:
        icon = (
          <FaWhatsappSquare
            key="whatsapp"
            color="#007E3A"
            size={size ? size : "1.5em"}
            className="channel"
            data-tooltip-id="channelTip"
            data-tooltip-content="WhatsApp"
          />
        );
        break;
      case UserChannel.FLEET_EDGE_AGENT:
        icon = (
          <img src={FleetEdgeChannelIcon}
            key="Fleet_Edge"
            color="#007E3A"
            size={size ? size : "1.5em"}
            className="channel"
            data-tooltip-id="channelTip"
            data-tooltip-content="Fleet Edge"
          />
        );
        break;
      case UserChannel.TELEGRAM:
        icon = (
          <FaTelegramPlane
            style={{
              borderRadius: 2,
              padding: 2,
              margin: 2,
              color: "white",
              background: "#0088CC",
            }}
            key="telegram"
            color="#0088CC"
            size={size ? size : "1.3em"}
            className="channel"
            data-tooltip-id="channelTip"
            data-tooltip-content="Telegram"
          />
        );
        break;
      case UserChannel.WHATSAPP_CV_SALES_BOT:
        icon = (
          <FaPhoneSquareAlt
            style={{
              borderRadius: 2,
              padding: 2,
              margin: 2,
              color: "white",
              background: "#0088CC",
            }}
            key="WHATSAPP_CV_SALES_BOT"
            color="#fff"
            size={size ? size : "1.3em"}
            className="channel"
            data-tooltip-id="channelTip"
            data-tooltip-content="cvSales"
          />
        );
        break;
      case UserChannel.TEAMS:
        icon = (
          <SiMicrosoftteams
            style={{
              borderRadius: 2,
              padding: 2,
              margin: 2,
              color: "white",
              background: "#464EB8",
            }}
            key="teams"
            color="#fff"
            size={size ? size : "1.3em"}
            className="channel"
            data-tooltip-id="channelTip"
            data-tooltip-content="Teams"
          />
        );
        break;
      default:
        return "";
    }
    return (
      <div>
        <Tooltip id="channelTip" className="tool-tip" style={tooltipStyle} disableStyleInjection="core" />
        {icon}
      </div>
    );
  };

  return <div className="channels-ctr">{renderChannelIcons()}</div>;
}

export default Channels;
